<template>
<div>

<b>Sprache:</b>&nbsp;
  <select v-model="language" v-on:change="languageChanged()">
    <option>DE</option>
    <option>EN</option>
    <option>FR</option>
  </select>

<br><br>
<!--
<div class="subject">
<b>Betreff:</b>&nbsp;<input type="text" v-model="subject" style="width: 90%;">
</div>
-->
  <div>
    <quill-editor ref="emailcontent"
                        v-model="content"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)"
                        @change="onEditorChange($event)"
                        >
          </quill-editor>
  </div>
<br>
<div style="display:block; ">
  <h3>{{status}}</h3>
  <button @click="sendEmailData()">Email-Texte übernehmen</button>&nbsp;<button @click="back()">Zurück</button>
</div>
<br>
<br>
<div>
<b>HINWEIS:</b> Die folgenden Texte werden in der Email durch entsprechende Händlerangaben ersetzt:
<ul>
<li><b>#vorname#</b> - wird in der Email durch den Vornamen des Händlers ersetzt.</li><br>
<li><b>#nachname#</b> - wird in der Email durch den Nachnamen des Händlers ersetzt.</li><br>
<li><b>#firma#</b> - wird in der Email durch Namen der Firma des Händlers ersetzt.</li>
</ul>

</div>
</div>


</template>
<script>

import { quillEditor } from 'vue-quill-editor'
import Config from '../Config'

export default {
  name: 'EmailEditor',
  props: {},
  data: function() {
    return {
      language: 'DE',
      subject: '',
      content: '',
      status: '',
      mails: {},
      config: Config,
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              ['link']
            ]
          }
        }
    }
  },
  components: {
    quillEditor
  },
  created: function() {
/*
    if(!this.user.logedin){
        this.$router.push({ path: 'login' })
    }
*/

    var oReq = new XMLHttpRequest();

    oReq.addEventListener("load", () => {
      let emails = JSON.parse(oReq.responseText);
      emails.DE = decodeURI(emails.DE);
      emails.EN = decodeURI(emails.EN);
      emails.FR = decodeURI(emails.FR);
      this.mails = emails;
      this.content = this.mails[this.language];
    });

    oReq.addEventListener("error", () => {
      alert(oReq.statusText);
    });

    oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/private/admin/defaultmail");

    oReq.setRequestHeader("x-access-token", this.config.masterpassword);
    oReq.send();


  },
  methods: {
      onEditorBlur(editor) {
        //console.log('editor blur!', editor)
      },
      onEditorFocus(editor) {
        //console.log('editor focus!', editor)
        this.status = "";
      },
      onEditorReady(editor) {
        //console.log('editor ready!', editor)
      },
      onEditorChange({ editor, html}) {
        // console.log('editor change!', editor, html, text)

        this.content = html;
        this.mails[this.language] = html;
      },
      languageChanged(){
        this.content = this.mails[this.language];
      },
      back(){
          this.$router.push({ path: 'operations' })
      },
      sendEmailData(){

        var oReq = new XMLHttpRequest();

        oReq.addEventListener("load", () => {
          let emails = JSON.parse(oReq.responseText);
          emails.DE = decodeURI(emails.DE);
          emails.EN = decodeURI(emails.EN);
          emails.FR = decodeURI(emails.FR);
          this.mails = emails;
          this.content = this.mails[this.language];
          this.status = "OK";
        });

        oReq.addEventListener("error", () => {
          alert(oReq.statusText);
        });

        oReq.open("PUT", this.config.protocol + "://" + this.config.apihost + "/private/admin/defaultmail");

        oReq.setRequestHeader("x-access-token", this.config.masterpassword);
        oReq.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        oReq.send("data=" + encodeURI(JSON.stringify(this.mails)));
      }
    }
}
</script>

<style>
.quill-editor,
  .quill-code {


  }
  .quill-editor {
    border: 1px solid #ccc;
    border-bottom: none;
    width: 80%;
    margin: auto;
    text-align: left;
    display: block;

  }
  .subject{
    width: 80%;
    margin: auto;
    margin-bottom: 20px;
  }

 select{

 }
  option{
    font-size: 20px;
    padding: 10px;
  }

</style>
